import * as React from 'react';


const LegalSuccess = (props) => {
  return (
    <div className="sett__view sett--verified">
      <div className="sett--verified__content">
        <div className="sett--verified__icon"><span className="i i-check"></span></div>
        <div className="sett--verified__title" >Your account is up to date and verified.</div>
        <div className="sett--verified__title__sub">Thank you!</div>
      </div>
    </div>
  );
};

export default LegalSuccess;
